module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-10-18 at 11.53.29 AM.254473b2.jpeg";